var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect';
import Layout from '@/container/Layout';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { useHotlineProDetailFetch } from '@/feature/hotline/professional/detail/hook/useHotlineProDetailFetch';
import { HotlineProDetailView } from '@/feature/hotline/professional/detail/index/page/HotlineProDetailView';
import { HotlineProDetailViewSkeleton } from '@/feature/hotline/professional/detail/index/page/HotlineProDetailViewSkeleton';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 匿名ホットライン コンサル詳細 詳細内容ページ（ロジック部分のみ）
 * @description api データ取得, その他ロジック部分
 */
export const HotlineProDetailPage = () => {
    const { id = '' } = useParams();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { detailData, fetchDetailData, isLoading } = useHotlineProDetailFetch({
        dispatch,
        id,
        unmountRef,
    });
    const detailOneData = detailData[id];
    // 詳細データ取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!detailOneData) {
                yield fetchDetailData();
            }
        }))();
    }, [detailOneData, fetchDetailData]);
    // ローディング中
    if (isLoading && !detailOneData) {
        return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineProDetailViewSkeleton, {}) })));
    }
    // データが取得できなかった場合
    if (!detailOneData) {
        return _jsx(CustomRedirect, { to: pagePath.hotline.professional.list() });
    }
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.professional.detail(detailOneData.id), title: `${detailOneData.title} | PROFFIT` }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineProDetailView, { detailData: detailOneData }) }))] }));
};
